import React from "react";
import { v4 as uuidv4 } from 'uuid';

import { GatsbyImage, getImage } from "gatsby-plugin-image";

import Link from "@components/link";
import SocialListing from "./social-listing";

import {
  Footer,
  FooterSection,
  FooterNav,
  FooterNavItem,
  FooterDetail,
  FooterPartners,
  FooterTitle,
} from "./style";

export const FooterComponent = ({
  content: { socialTitle, socialProfiles, partnersTitle, partners },
  nav,
}) => {
  return (
    <Footer>
      <h2 className="sr-only">Footer</h2>
      <FooterDetail>
        <FooterSection>
          {socialProfiles && (
            <SocialListing title={socialTitle} profiles={socialProfiles} />
          )}
          {nav && (
            <FooterNav aria-label="Navigation">
              {nav.map((item) => (
                <FooterNavItem key={uuidv4()}>
                  <Link {...item} />
                </FooterNavItem>
              ))}
            </FooterNav>
          )}
        </FooterSection>

        {partners && (
          <FooterSection className="partners-section">
            {partnersTitle && <FooterTitle>{partnersTitle}</FooterTitle>}
            <FooterPartners>
              {partners.map(({ partnerLink, partnerLogo }) => {

                if (partnerLink?.url) {
                  return (
                    <Link url={partnerLink?.url} key={uuidv4()} target="_blank">
                      {partnerLogo && partnerLogo?.localFile ? 
                      <GatsbyImage
                          image={getImage(partnerLogo?.localFile) || partnerLogo?.previewFile}
                          alt={partnerLink.text || ""}
                        />
                      : <img src={partnerLogo?.previewFile} /> }
                    </Link>
                  );
                }
                return "";
              })}
            </FooterPartners>
          </FooterSection>
        )}
      </FooterDetail>
    </Footer>
  );
};

export default FooterComponent;
